import styled from "styled-components";
import { flexbox, layout, grid, border, space } from "styled-system";

export const Nav = styled.nav`
  padding: 10px;
  ${layout};
  ${flexbox};
  ${grid};
  ${border}
  ${space};
`;
